import { useSearchParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, Construction } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function BimssComingSoonPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const title = searchParams.get('title') ?? 'Service'

  return (
    <div className="min-h-screen flex flex-col pb-24">
      {/* Header with back button */}
      <div className="sticky top-14 bg-background/95 backdrop-blur z-10 border-b">
        <div className="px-3 py-2 flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/bimss')}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="font-semibold truncate">BIMSS · {title}</h1>
        </div>
      </div>

      {/* Hero content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center gap-5">
        <div className="w-32 h-32 rounded-full bg-red-100 flex items-center justify-center">
          <Construction className="h-16 w-16 text-red-600" strokeWidth={1.5} />
        </div>

        <div className="space-y-2 max-w-sm">
          <h2 className="text-xl font-bold tracking-wide">BIMSS · {title}</h2>
          <p className="text-2xl font-extrabold text-red-600 tracking-wide">
            COMING SOON!!!
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            We're working on this feature for your barangay. Check back soon.
          </p>
        </div>

        <Button
          onClick={() => navigate('/bimss')}
          variant="outline"
          className="mt-4 rounded-full px-6"
        >
          Back to Services
        </Button>
      </div>
    </div>
  )
}
